import { IOption } from 'components/Select/type';
import i18n from 'providers/i18n/i18n';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import countriesJSON from 'assets/countries.json';
import { ICountry } from 'types/Country.types';

export const useGetAllowedDeliveryCountryOptions = (
  allowedDeliveryCountries: string[] | null
) => {
  const { t } = useTranslation();

  const countries = [...countriesJSON];
  const countryOptions: IOption[] = useMemo(
    () =>
      countries
        .filter((country: ICountry) =>
          allowedDeliveryCountries?.includes(country.cca2.toUpperCase())
        )
        .sort((a: ICountry, b: ICountry) => {
          const allowed = allowedDeliveryCountries ?? [];
          const indexA = allowed.indexOf(a.cca2.toUpperCase());
          const indexB = allowed.indexOf(b.cca2.toUpperCase());

          // Preserve provided order (e.g. NL, BE, RS)
          if (indexA !== -1 && indexB !== -1) {
            return indexA - indexB;
          }

          const nameA = a.name.toUpperCase();
          const nameB = b.name.toUpperCase();

          if (nameA < nameB) {
            return -1;
          } else if (nameA > nameB) {
            return 1;
          } else {
            return 0;
          }
        })
        .map((country: ICountry) => {
          return {
            value: country.cca2,
            label: `${t(country.name)}`,
            key: country.name,
          };
        }),
    [allowedDeliveryCountries, countries, i18n.resolvedLanguage]
  );

  return countryOptions;
};
